import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { historyReducer } from './history.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('history', historyReducer)
  ]
})
export class HistoryStoreModule { }
